import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { InputText } from 'primereact/inputtext';
import { RibService } from "../../../service/RibService";
import { Toast } from "primereact/toast";

export const Iban = ({ label, onValueChange, disabled, disabled2, onClickEventer, isIbanValide }) => {

    const ribService = new RibService();
    const [values, setValues] = useState(Array(7).fill(""));
    const toast = useRef(null);
    const cursorPositionsRef = useRef([]);

    const handleIbanChange = (index, value) => {
        // Restreindre la saisie à 4 chiffres et lettres sauf pour la dernière cellule
        const maxChars = index === values.length - 1 ? 3 : 4;
        const sanitizedValue = value.slice(0, maxChars).replace(/[^0-9a-zA-Z]/g, '');

        // Créer une copie du tableau des valeurs
        const newValues = [...values];
        newValues[index] = sanitizedValue.toUpperCase();

        // Mettre à jour l'état avec le nouveau tableau de valeurs
        setValues(newValues);

        // Appeler la fonction de mise à jour avec le nouvel IBAN complet
        onValueChange(newValues.join(""));
    };

    

    const saveCursorPosition = (index, position) => {
        cursorPositionsRef.current[index] = position;
    };

    // Vérification 1 : Position du code pays
    const countryCodeValid = () => {
        const otherValue = values[0].substring(0, 2);
        otherValue === "FR" || otherValue === "MC" ? disabled2(true) : showInfo("IBAN ETRANGER");
    }

    // Vérification 2 : Code Banque
    const codeBanque = () => {
        const val = values[1].substring(0, 4) + values[2].substring(0, 1);

        ribService
            .getCodeBanque(val)
            .then((res) => {
                if (res.data > 0) {
                    codeGuichet();
                } else {
                    showInfo("Le code IBAN indiqué ne peut pas être utilisé (format invalide). Vérifiez s’il ne comporte pas une erreur.");
                }
            })
            .catch((err) => {
                window.location = "/#/serviceIndisponible/" + err.response.data.errorId;
            });
    };

    // Vérification 3 : Code Guichet
    const codeGuichet = () => {
        const val = values[2].substring(1, 4) + values[3].substring(0, 2);

        ribService
            .getCodeGuichet(val)
            .then((res) => {
                if (res.data > 0) {
                    calculerCleRibAndIban();
                } else {
                    showInfo("Le code IBAN indiqué ne peut pas être utilisé (format invalide). Vérifiez s’il ne comporte pas une erreur.");
                }
            })
            .catch((err) => {
                window.location = "/#/serviceIndisponible/" + err.response.data.errorId;
            });
    }

    // Vérification 4 : Validité de la clé RIB et Iban
    const calculerCleRibAndIban = () => {
        
        // Construction du numéro de compte à partir des éléments du tableau values
        const numeroCompte = values.slice(1).join(''); // Concatène tous les éléments sauf le premier (code pays + clé IBAN)

        // Récupération du code du pays et de la clé IBAN
        const codePaysCleIBAN = values[0]; // "FR76" dans cet exemple

        // Construction de l'IBAN complet pour la vérification
        const ibanToCheck = codePaysCleIBAN + numeroCompte;

        const ibanCompletReorganise = ibanToCheck.substring(4) + ibanToCheck.substring(0, 4);
        const ibanCompletConverti = ibanCompletReorganise.split('').map(char => {
            return isNaN(char) ? (char.charCodeAt(0) - 55).toString() : char;
        }).join('');

                // Validation de l'IBAN
        const remainder = ibanCompletConverti.match(/\d{1,7}/g).reduce((acc, num) => 
            (acc + num) % 97, 0
        );

        const isValid = remainder === 1;

        if (isValid) {
            countryCodeValid();
            isIbanValide(isValid);
        } else {
            isIbanValide(isValid);
        }
    }

    const showInfo = (msg) => {
    
        {/*
        toast.current.show({
            severity: "error",
            summary: "IBAN Invalid",
            detail: msg,
            life: 5000,
        });
        */}

    };

    useEffect(() => {
        const joinedValuesLength = values.join("").length;
        if (joinedValuesLength >= 27) {
            codeBanque();
        }
    }, [values]);


    // Initialiser les champs à zéro lorsque le composant est monté
    useEffect(() => {
        if (disabled) {
            setValues(["FR76", "9999", "9999", "9999", "9999", "9999", "944"]);
            onValueChange(values);
        } 
        else{
            setValues(Array(7).fill(""));
            onValueChange(values);
        }
    }, [disabled]);

    useEffect(() => {
        values.forEach((value, index) => {
            const input = document.getElementById(`input-${index}`);
            if (input && cursorPositionsRef.current[index] !== undefined) {
                input.setSelectionRange(cursorPositionsRef.current[index], cursorPositionsRef.current[index]);
            }
        });
    }, [values]);


    return (
        <div>
            <Toast ref={toast} position="top-center" className="toast-position" />
            <div className="iban-input">
                {values.map((value, index) => (
                    <InputText
                        key={index}
                        id={`input-${index}`}
                        value={value}
                        onChange={(e) => {
                            saveCursorPosition(index, e.target.selectionStart);
                            handleIbanChange(index, e.target.value);
                        }}
                        disabled={disabled}
                        style={{
                            width: index === values.length - 1 ? '53px' : '65px',
                            marginRight: '5px',
                            letterSpacing: '5px',
                        }}
                    />
                ))}
            </div>
        </div>
    );
};
 